<template>
    <div id="app" class="app-layout d-flex flex-column">
        <app-header v-if="isShow"></app-header>
        <app-container>
            <slot></slot>
        </app-container>
        <app-footer v-if="footer && isShow"></app-footer>
    </div>
</template>

<script>
import AppContainer from './app/app-container';
import AppFooter from './app/app-footer';
import AppHeader from './app/app-header';

export default {
    name: 'AppLayout',

    components: { AppContainer, AppFooter, AppHeader },

    props: {
        footer: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        isShow() {
            return window.self === window.top;
        }
    }
};
</script>

<style lang="scss" scoped></style>
